import { ReactTable } from "@aix/ui"
import { useNavigate, useSearch } from "@tanstack/react-router"

import { trpc } from "../../lib/trpc"

export default function MonitorsTab() {
  const navigate = useNavigate()
  const search = useSearch({ strict: false }) as { tab?: string; monitorSlug?: string; jobId?: string }
  const utils = trpc.useUtils()
  const { data, isLoading } = trpc.scraping.listMonitors.useQuery()
  const { mutateAsync: syncMonitors, isLoading: syncing } = trpc.scraping.syncRegistryMonitors.useMutation({
    onSuccess: () => utils.scraping.listMonitors.invalidate(),
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-6 w-6 border-2 border-blue-600 border-t-transparent"></div>
          <span className="text-primary">Loading monitors...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-semibold ">Monitors</h2>
          <p className="text-sm text-primary">Configure and manage your scraping monitors</p>
        </div>
        <button
          className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          onClick={() => syncMonitors()}
          disabled={syncing}
        >
          {syncing && (
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
          )}
          {syncing ? "Syncing..." : "Sync Registry Monitors"}
        </button>
      </div>

      <div className="bg-background border border-border rounded-lg overflow-hidden">
        <ReactTable
          data={(data || []).map((m: any) => ({
            slug: m.slug,
            name: m.name,
            enabled: m.enabled,
            schedule: m.schedule || "0 7 * * *",
            lastRun: m.lastRunAt ? new Date(m.lastRunAt).toLocaleString() : "-",
          }))}
          columns={[
            {
              Header: "Slug",
              accessor: "slug",
              Cell: ({ row: { original } }) => <div className="font-mono text-sm ">{original.slug}</div>,
            },
            {
              Header: "Name",
              accessor: "name",
              Cell: ({ row: { original } }) => <div className="font-medium ">{original.name}</div>,
            },
            {
              Header: "Enabled",
              accessor: "enabled",
              Cell: ({ row: { original } }) => (
                <span
                  className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    original.enabled ? "bg-green-100 text-green-800" : "bg-red-100 text-destructive"
                  }`}
                >
                  {original.enabled ? "Active" : "Inactive"}
                </span>
              ),
            },
            {
              Header: "Schedule",
              accessor: "schedule",
              Cell: ({ row: { original } }) => (
                <div className="font-mono text-xs text-primary">{original.schedule}</div>
              ),
            },
            {
              Header: "Last Run",
              accessor: "lastRun",
              Cell: ({ row: { original } }) => <div className="text-sm text-primary">{original.lastRun}</div>,
            },
            {
              Header: "Actions",
              accessor: "slug",
              Cell: ({ row: { original } }) => (
                <button
                  className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-background text-primary  transition-colors"
                  onClick={() =>
                    navigate({
                      to: "/scraping",
                      // @ts-ignore
                      search: { ...search, tab: "jobs", monitorSlug: original.slug },
                    })
                  }
                >
                  See all Jobs
                </button>
              ),
            },
          ]}
          enableSorting
          enablePagination
        />
      </div>
    </div>
  )
}
